import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import './SellWithUs.scss';
import review from '../../images/review-mob.svg';
import reviewTab from '../../images/review-tab.svg';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import classNames from 'classnames';
import HTMLReactParser from 'html-react-parser';
import { convertBrToP , extractFAQFromHTML } from '../common/htmlUtils';
import { Helmet } from "react-helmet";

const SellWithUs = (props) => {
    let titleText = "";
    if(props?.data?.Title) {
        titleText = props?.data?.Title
    }

    var faqItems = extractFAQFromHTML(props?.data?.Content);
    //console.log("faqItems:", faqItems);
    var faqschemaList = [];
        
        faqItems?.map((faqitem,i) =>{
            faqschemaList.push({
                "@type": "Question",
                "name": `${faqitem?.question}`,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": `${faqitem?.answer}`
                }
            })
        })    
    
	return( 
     <section className='sell-with-us' id={props?.data?.Anchor_Id}>
        {faqItems?.length > 0 && props?.pageClass === "renters-rights-bill" &&(
                <Helmet>
                   <script type="application/ld+json">{`{
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": ${JSON.stringify(faqschemaList, null, 2)}
                        }`}
                  </script> 
               </Helmet>
            )}
		<Container className='position-relative'>
			<Row className={classNames("justify-content-between", 
                // {"align-items-center": props?.data?.Accordian_List?.length == 0 }
            )}>
				<Col xl={6}>
					<div className="img-wrap">
                        <GatsbyImage
                            image={getImage(Array.isArray(props?.data?.Acc_Image) ? props?.data?.Acc_Image[0]?.url_sharp : props?.data?.Acc_Image?.url_sharp)} 
                            alt={props?.data?.Acc_Image?.alternativeText ? props?.data?.Acc_Image?.alternativeText : props?.data?.Sm_Title+" - tlc Estate Agents"}
                            className={classNames("", { "gatsby-img-h-100 object-pt" : props?.data?.Accordian_List?.length == 0 })}
                        />
					</div>
                </Col>
                <Col xl={6}>
                    {props?.data?.Sm_Title && <div className="heading pt-2">{props?.data?.Sm_Title}</div>}
                    <h2>{HTMLReactParser(titleText)}</h2>
                    {props?.data?.Content && <div class="content">{HTMLReactParser(convertBrToP(props?.data?.Content))}</div>}
                    <Accordion defaultActiveKey={0}>
                        {props?.data?.Accordian_List.map((each, i) => 
                            <Accordion.Item eventKey={i} key={each._id}>
                                <Accordion.Header>{each.Title}</Accordion.Header>
                                <Accordion.Body>
                                    {each.Content && <p>
                                        {HTMLReactParser(each.Content)}
                                    </p>}
                                </Accordion.Body>
                            </Accordion.Item>
                        )}
                    </Accordion>
					<div className="review-wrap">
						<div className="img-wrap">
							<picture>
								<source media='(min-width: 768px)' srcSet={reviewTab}/>
								<img src={review} alt="review" />
							</picture>
                           
						</div>
						<div className="text-wrap"><strong>4.9/5</strong> from our valued customers.</div>
						<div className="text-wrap td">Rated <strong>4.9 out of 5</strong> from our valued customers.</div>
					</div>
				</Col>
			</Row>
		</Container>
	</section>
    )
};

export default SellWithUs;
